module.exports = __webpack_public_path__ + "static/img/manual-31.165e182.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-31.png
// module id = VTfX
// module chunks = 4